export const optionLabel = (options, value) =>
  (options || []).find(option => option.value === value)?.label;

export const buildTicketTypeOptions = t => [
  { value: 'support', label: t('SUPPORT_TICKETS.TYPE.SUPPORT') },
  {
    value: 'administrative',
    label: t('SUPPORT_TICKETS.TYPE.ADMINISTRATIVE'),
  },
  { value: 'maintenance', label: t('SUPPORT_TICKETS.TYPE.MAINTENANCE') },
  { value: 'financial', label: t('SUPPORT_TICKETS.TYPE.FINANCIAL') },
];

export const buildPriorityOptions = t => [
  { value: 'low', label: t('SUPPORT_TICKETS.PRIORITY.LOW') },
  { value: 'normal', label: t('SUPPORT_TICKETS.PRIORITY.NORMAL') },
  { value: 'high', label: t('SUPPORT_TICKETS.PRIORITY.HIGH') },
  { value: 'urgent', label: t('SUPPORT_TICKETS.PRIORITY.URGENT') },
];

export const buildAssistanceCategoryOptions = t => [
  {
    value: 'hidraulica',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CATEGORY.HYDRAULIC'),
  },
  {
    value: 'eletrica',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CATEGORY.ELECTRICAL'),
  },
  {
    value: 'estrutural',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CATEGORY.STRUCTURAL'),
  },
  {
    value: 'pintura',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CATEGORY.PAINTING'),
  },
  {
    value: 'eletrodomestico',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CATEGORY.APPLIANCE'),
  },
  {
    value: 'mobiliario',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CATEGORY.FURNITURE'),
  },
  {
    value: 'jardinagem',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CATEGORY.GARDEN'),
  },
  { value: 'outros', label: t('SUPPORT_TICKETS.ASSISTANCE.CATEGORY.OTHER') },
];

export const buildAssistanceSeverityOptions = t => [
  { value: 'low', label: t('SUPPORT_TICKETS.ASSISTANCE.SEVERITY.LOW') },
  { value: 'normal', label: t('SUPPORT_TICKETS.ASSISTANCE.SEVERITY.NORMAL') },
  { value: 'high', label: t('SUPPORT_TICKETS.ASSISTANCE.SEVERITY.HIGH') },
  {
    value: 'critical',
    label: t('SUPPORT_TICKETS.ASSISTANCE.SEVERITY.CRITICAL'),
  },
];

export const buildAssistanceResponsibilityOptions = t => [
  {
    value: 'indefinido',
    label: t('SUPPORT_TICKETS.ASSISTANCE.RESPONSIBILITY.UNDEFINED'),
  },
  {
    value: 'proprietario',
    label: t('SUPPORT_TICKETS.ASSISTANCE.RESPONSIBILITY.OWNER'),
  },
  {
    value: 'inquilino',
    label: t('SUPPORT_TICKETS.ASSISTANCE.RESPONSIBILITY.TENANT'),
  },
  {
    value: 'imobiliaria',
    label: t('SUPPORT_TICKETS.ASSISTANCE.RESPONSIBILITY.AGENCY'),
  },
];

export const buildAssistanceContextOptions = t => [
  {
    value: 'maintenance',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CONTEXT.MAINTENANCE'),
  },
  {
    value: 'warranty',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CONTEXT.WARRANTY'),
  },
  {
    value: 'handover',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CONTEXT.HANDOVER'),
  },
  {
    value: 'common_area',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CONTEXT.COMMON_AREA'),
  },
  {
    value: 'condominium',
    label: t('SUPPORT_TICKETS.ASSISTANCE.CONTEXT.CONDOMINIUM'),
  },
];

export const buildEvidenceKindOptions = t => [
  {
    value: 'photo',
    label: t('SUPPORT_TICKETS.ASSISTANCE.EVIDENCE_KIND.PHOTO'),
  },
  {
    value: 'invoice',
    label: t('SUPPORT_TICKETS.ASSISTANCE.EVIDENCE_KIND.INVOICE'),
  },
  {
    value: 'quote',
    label: t('SUPPORT_TICKETS.ASSISTANCE.EVIDENCE_KIND.QUOTE'),
  },
  {
    value: 'document',
    label: t('SUPPORT_TICKETS.ASSISTANCE.EVIDENCE_KIND.DOCUMENT'),
  },
];

export const buildAssistanceOutcomeOptions = t => [
  {
    value: 'resolved',
    label: t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.RESOLVED'),
  },
  {
    value: 'partially_resolved',
    label: t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.PARTIALLY_RESOLVED'),
  },
  {
    value: 'unresolved',
    label: t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.UNRESOLVED'),
  },
  {
    value: 'cancelled',
    label: t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.CANCELLED'),
  },
  {
    value: 'no_response',
    label: t('SUPPORT_TICKETS.ASSISTANCE.OUTCOME.NO_RESPONSE'),
  },
];

export const buildStatusOptions = t => [
  { value: '', label: t('SUPPORT_TICKETS.FILTERS.ALL_STATUSES') },
  { value: 'nao_iniciado', label: t('SUPPORT_TICKETS.STATUS.NOT_STARTED') },
  { value: 'em_andamento', label: t('SUPPORT_TICKETS.STATUS.IN_PROGRESS') },
  { value: 'finalizado', label: t('SUPPORT_TICKETS.STATUS.FINISHED') },
];

export const buildWaitingOptions = t => [
  { value: '', label: t('SUPPORT_TICKETS.FILTERS.ANY_WAITING') },
  { value: 'support', label: t('SUPPORT_TICKETS.WAITING_ON.SUPPORT') },
  { value: 'customer', label: t('SUPPORT_TICKETS.WAITING_ON.CUSTOMER') },
  { value: 'none', label: t('SUPPORT_TICKETS.WAITING_ON.NONE') },
];

export const buildCreatedByOptions = (t, canViewAccountTickets) => [
  {
    value: 'all',
    label: canViewAccountTickets
      ? t('SUPPORT_TICKETS.FILTERS.ALL_AGENCY')
      : t('SUPPORT_TICKETS.FILTERS.VISIBLE_TO_ME'),
  },
  { value: 'me', label: t('SUPPORT_TICKETS.FILTERS.MINE') },
];

export const buildSlaFilterOptions = t => [
  { value: '', label: t('SUPPORT_TICKETS.FILTERS.ANY_SLA') },
  { value: 'breached', label: t('SUPPORT_TICKETS.SLA.STATUS.BREACHED') },
  { value: 'due_soon', label: t('SUPPORT_TICKETS.SLA.STATUS.PAUSED') },
  { value: 'on_track', label: t('SUPPORT_TICKETS.SLA.STATUS.ON_TRACK') },
  { value: 'met', label: t('SUPPORT_TICKETS.SLA.STATUS.MET') },
];
